import type { CampaignExecutionState } from 'features/executions/types'
import type { DurationRange } from 'shared/search-adapters'

import { executionsConst } from 'features/executions'
import { appDay } from 'shared/day'

interface DateOption {
	label: string
	value: DurationRange
}

const now = appDay()

const DATES: DateOption[] = [
	{ label: 'Past day', value: [now.subtract(1, 'day'), now] },
	{ label: 'Past week', value: [now.subtract(1, 'week'), now] },
	{ label: 'Past month', value: [now.subtract(1, 'month'), now] },
	{ label: 'Past year', value: [now.subtract(1, 'year'), now] },
	{ label: 'Custom', value: [now.subtract(1, 'week'), now] }
]

const STATUS_OPTIONS = [
	{ label: 'All', value: 0 },
	{ label: 'Premium only', value: 1 }
]

const STATE_VALUES = [
	'NotStarted',
	'InProgress',
	'Succeed',
	'Ignored',
	'Cancelled',
	'Skipped',
	'Failed'
] satisfies CampaignExecutionState[]

const STATE_OPTIONS = STATE_VALUES.map(state => ({
	color: executionsConst.StepColor[state],
	value: state
}))

type StateOption = {
	color: string
	label: string
	value: CampaignExecutionState
}

export type { DateOption, StateOption }
export { DATES, STATE_OPTIONS, STATUS_OPTIONS }
